import { MediumValueTxt, ValueTxt } from '../styledComponent/Common'
import { Box, Skeleton } from '@mui/material'

const customerInfoText = ({ loading, isSame, value, tempValue }: { loading?: boolean, isSame: boolean, value: string, tempValue?: string }) => {
    return (
        <>
            {
                loading ? <LoadingTxt /> : <Box sx={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                    <ValueTxt isSame={isSame} >{value ?? "N/A"} </ValueTxt>
                    {
                        tempValue && isSame ? <ValueTxt>{tempValue}</ValueTxt> : null
                    }
                </Box>
            }
        </>
    )
}

export default customerInfoText

export const LoadingTxt = () => {
    return (
        <>
            <Skeleton variant="text" height={20} width={100} />
        </>
    )
}

export const TextLoading = ({ loading, value }: { loading?: boolean, value: string }) => {
    return (
        <>
            {
                loading ? <LoadingTxt /> : <MediumValueTxt>{value ?? "N/A"}</MediumValueTxt>
            }
        </>
    )
}